import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import AppRoutes from "@/routes";

// Scroll to hash target after route change (e.g. /#events from another page)
const HashScroller = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    const id = hash.replace("#", "");
    // Small delay so the home page has rendered its sections
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
    return () => clearTimeout(t);
  }, [hash, pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HashScroller />
        <AppRoutes />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid #2A2A2A",
            color: "#F4F4F5",
            borderRadius: "0px",
            fontFamily: '"DM Sans", sans-serif',
          },
        }}
      />
    </div>
  );
}

export default App;
